import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { SnackbarProvider, SnackbarKey } from 'notistack';
import CloseIcon from '@mui/icons-material/Close';

(async () => {
  try {
    await fetch(`${process.env.REACT_APP_API_PATH!}/api/health`, { redirect: "error", credentials: "include" });
    const notistackRef: React.RefObject<SnackbarProvider> = React.createRef();
    const onClickDismiss = (key: SnackbarKey) => () => {
      notistackRef?.current?.closeSnackbar(key);
    };

    ReactDOM.render(
      <React.StrictMode>
        <SnackbarProvider
          maxSnack={5}
          ref={notistackRef}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          action={(key: SnackbarKey) => (
            <CloseIcon onClick={onClickDismiss(key)} >
              閉じる
            </CloseIcon>
          )}
        >
          <App />
        </SnackbarProvider>
      </React.StrictMode>,
      document.getElementById('root')
    );

    // If you want to start measuring performance in your app, pass a function
    // to log results (for example: reportWebVitals(console.log))
    // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
    reportWebVitals();

  } catch {
    location.href = `${process.env.REACT_APP_API_PATH!}/api/login?redirect=${process.env.REACT_APP_BASE_PATH!}`;
  }
})();
